import { render, staticRenderFns } from "./SyncFacilityModalGroup.vue?vue&type=template&id=1260e388&scoped=true&"
import script from "./SyncFacilityModalGroup.vue?vue&type=script&lang=js&"
export * from "./SyncFacilityModalGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1260e388",
  null
  
)

export default component.exports